export default "__VITE_ASSET__43bbc7e4__"